/* Value pack cupcake and silvana mixes: the steppers fill one readable line property per group.
   On a product form an incomplete mix is a custom validity error, so native, drawer and sticky adds all stop on it. */
(() => {
  function init(root = document) {
    root.querySelectorAll('[data-pack-mix]').forEach(mix => {
      if (mix.dataset.packMixReady) return;
      mix.dataset.packMixReady = 'true';
      const need = Number(mix.dataset.packMixCount);
      const group = mix.dataset.packMixLabel;
      const inputs = [...mix.querySelectorAll('[data-pack-mix-flavour]')];
      const value = mix.querySelector('[data-pack-mix-value]');
      const status = mix.querySelector('[data-pack-mix-status]');
      const update = () => {
        const counts = inputs.map(input => input.value === '' ? 0 : Number(input.value));
        const whole = counts.every(count => Number.isSafeInteger(count) && count >= 0);
        const total = whole ? counts.reduce((sum, count) => sum + count, 0) : 0;
        const complete = whole && total === need;
        value.value = complete ? inputs.filter(input => Number(input.value) > 0).map(input => `${Number(input.value)} × ${input.dataset.packMixFlavour}`).join(', ') : '';
        const message = !whole ? 'Use whole numbers for each flavour.'
          : total > need ? `That’s ${total} ${group}. Take off ${total - need} to make ${need}.`
          : total < need ? `Choose ${need - total} more ${group} (${total} of ${need}).` : '';
        status.textContent = complete ? `All ${need} ${group} chosen.` : total === 0 && whole ? `Pick any mix of flavours, ${need} in total.` : message;
        inputs.forEach(input => input.setCustomValidity(''));
        inputs[0].setCustomValidity(message || '');
        mix.classList.toggle('is-complete', complete);
        mix.classList.toggle('is-over', whole && total > need);
        inputs.forEach(input => {
          const count = Number(input.value) || 0;
          const [less, more] = input.parentElement.querySelectorAll('[data-pack-mix-step]');
          less.disabled = count <= 0;
          more.disabled = total >= need;
          input.closest('.hb-pack-mix__row')?.classList.toggle('is-picked', count > 0);
        });
      };
      mix.addEventListener('click', event => {
        const button = event.target.closest('[data-pack-mix-step]');
        if (!button) return;
        const input = button.parentElement.querySelector('input');
        input.value = String(Math.max(0, (Number(input.value) || 0) + Number(button.dataset.packMixStep)));
        update();
        // Keep focus in the row when a button disables itself (0 or a full mix), without raising a phone keyboard.
        if (button.disabled) button.parentElement.querySelector(`[data-pack-mix-step="${-Number(button.dataset.packMixStep)}"]`).focus();
      });
      mix.addEventListener('input', update);
      mix.addEventListener('change', update);
      mix.querySelectorAll('[data-pack-mix-step]').forEach(button => { button.hidden = false; });
      // Without a form owner (the cart card) the steppers never block the cart form; callers check validity themselves.
      mix.hbCheck = () => { update(); if (value.value) return true; status.textContent = inputs[0].validationMessage || status.textContent; status.classList.add('is-error'); inputs[0].reportValidity?.(); return false; };
      mix.addEventListener('input', () => status.classList.remove('is-error'));
      update();
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
